import React from 'react';
import { css } from '@emotion/react';

import NvRadioButton from 'shared/components/inputs/nv-radio-button';
import { primary, gray4, gray7 } from 'styles/global_defaults/colors';
import { halfSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';
import { blue05 } from 'athena/styles/colors';
import { RoleplayApprovalMode } from 'redux/schemas/models/institution';

const RADIO_NAME = 'roleplay-approval-mode';

type ApprovalOptionProps = {
  mode: RoleplayApprovalMode,
  label: string,
  description: string,
  selected: boolean,
  dataQa: string,
  onSelect: (mode: RoleplayApprovalMode) => void,
};

const optionStyles = (selected: boolean) => css`
  border: 1px solid ${selected ? primary : gray4};
  background-color: ${selected ? blue05 : gray7};
  border-radius: ${halfSpacing}px;
  padding: ${threeQuartersSpacing}px;
  cursor: pointer;

  /* Let mouse clicks fall through to the card's onClick so selection is handled
    once; the radio stays keyboard-operable via onChange. */
  .approval-option-radio {
    pointer-events: none;
  }
`;

const ApprovalOption = ({
  mode,
  label,
  description,
  selected,
  dataQa,
  onSelect,
}: ApprovalOptionProps) => (
  <div
    css={optionStyles(selected)}
    onClick={() => onSelect(mode)}
    data-qa={dataQa}
  >
    <NvRadioButton
      name={RADIO_NAME}
      value={mode}
      label={label}
      labelClassName='text-large-body'
      checked={selected}
      onChange={() => onSelect(mode)}
      className='mt-0 approval-option-radio'
    />
    <div>{description}</div>
  </div>
);

export default ApprovalOption;
